import '../scss/main.scss';
import '../scss/critical-styles.scss';

document.addEventListener('DOMContentLoaded', function() {
	const searchButtons = document.querySelectorAll('.search-button');
	const searchContainer = document.getElementById('search-container');

	if (window.location.search.includes('s=')) {
		return;
	}

	searchButtons.forEach(function(button) {
		button.addEventListener('click', function() {
			searchContainer.classList.toggle('hidden');
		});
	});
});

document.addEventListener("DOMContentLoaded", function () {
	const switchers = document.querySelectorAll(".lang-switcher");

	switchers.forEach((switcher) => {
		const button = switcher.querySelector(".lang-current");

		if (!button) return;

		button.addEventListener("click", function (e) {
			e.preventDefault();

			switchers.forEach((s) => {
				if (s !== switcher) s.classList.remove("active");
			});

			switcher.classList.toggle("active");
		});

		switcher.querySelectorAll(".lang-dropdown a").forEach((link) => {
			link.addEventListener("click", () => {
				switcher.classList.remove("active");
			});
		});
	});

	document.addEventListener("click", function (e) {
		if (!e.target.closest(".lang-switcher")) {
			switchers.forEach((s) => s.classList.remove("active"));
		}
	});
});


document.addEventListener("DOMContentLoaded", function () {
	const mobileMenu = document.querySelector(".mobile-menu");
	if (!mobileMenu) return;

	const menuParents = mobileMenu.querySelectorAll(".menu-item-has-children > a");

	menuParents.forEach(link => {
		link.addEventListener("click", function (event) {
			const parentItem = this.parentElement;

			if (parentItem.querySelector(".sub-menu")) {
				event.preventDefault();

				parentItem.classList.toggle("active");

				mobileMenu.querySelectorAll(".menu-item-has-children").forEach(item => {
					if (item !== parentItem) {
						item.classList.remove("active");
					}
				});
			}
		});
	});
});


document.querySelector('.top-menu__burger-menu').addEventListener('click', function () {
	const burgerMenu = this; // Reference to the clicked burger menu
	const mobileMenu = document.querySelector('.mobile-menu');
	const body = document.body;

	// Toggle the active class on both elements
	burgerMenu.classList.toggle('active');
	mobileMenu.classList.toggle('active');
	body.classList.toggle('disable-scroll');
});

document.querySelectorAll('.theme-switcher').forEach((btn) => {
	btn.addEventListener('click', () => {
		if (window.forceDarkTheme) return; // ignore on this page
		const currentTheme = localStorage.getItem('theme') || 'light';
		const newTheme = currentTheme === 'light' ? 'dark' : 'light';
		localStorage.setItem('theme', newTheme);
		document.cookie = `theme=${newTheme}; path=/; SameSite=Lax`;
		location.reload();
	});
});

document.addEventListener("DOMContentLoaded", function () {
	const burgerBtn = document.querySelector('.main-nav__burger-menu');
	if (!burgerBtn) return;

	const mobileMenu = document.querySelector('.desctop-menu');
	const body = document.body;

	burgerBtn.addEventListener('click', function () {
		const burgerMenu = this;

		burgerMenu.classList.toggle('active');
		mobileMenu.classList.toggle('active');
		body.classList.toggle('disable-scroll');

		if (burgerMenu.classList.contains('active')) {
			document.addEventListener('click', handleClickOutside);
		} else {
			document.removeEventListener('click', handleClickOutside);
		}

		function handleClickOutside(event) {
			if (!mobileMenu.contains(event.target) && !burgerMenu.contains(event.target)) {
				burgerMenu.classList.remove('active');
				mobileMenu.classList.remove('active');
				body.classList.remove('disable-scroll');
				document.removeEventListener('click', handleClickOutside);
			}
		}
	});
});


document.addEventListener('DOMContentLoaded', () => {
	const getCookie = (name) => {
		const cookies = document.cookie.split('; ');
		for (let i = 0; i < cookies.length; i++) {
			const [key, value] = cookies[i].split('=');
			if (key === name) return value;
		}
		return null;
	};

	if (window.forceDarkTheme) {
		document.body.classList.remove('light-theme');
		document.body.classList.add('dark-theme');
		return; // do not read or write storage here
	}

	const savedTheme = getCookie('theme') || 'light';
	document.body.classList.add(`${savedTheme}-theme`);
});


jQuery(document).ready(function($) {
	// Initialize each slider with its settings
	$('.slider').each(function() {
		var $slider   = $(this),
			settings = $slider.data('settings');
		$slider.slick(settings);
	});

	// Handle unslick at a specific breakpoint
	$('.slider').on('breakpoint', function(event, slick, breakpoint) {
		if (breakpoint === 768) {
			slick.unslick();
		}
	});
});


const radioItems = document.querySelectorAll('.wpcf7-radio .wpcf7-list-item');
const acceptanceItems = document.querySelectorAll('.wpcf7-acceptance .wpcf7-list-item');

radioItems.forEach(item => {
	item.addEventListener('click', function() {
		radioItems.forEach(radioItem => {
			radioItem.classList.remove('active');
		});

		this.classList.add('active');

		const radioInput = this.querySelector('input[type="radio"]');
		if (radioInput) {
			radioInput.checked = true;
		}
	});
});


document.querySelectorAll('.wpcf7-acceptance input[type="checkbox"]').forEach(cb => {
	cb.addEventListener('change', function () {
		const parent = this.closest('.wpcf7-list-item');
		if (parent) {
			parent.classList.toggle('active', this.checked);
		}
	});
});

function toggleSubmitButton() {
	const checkboxes = document.querySelectorAll('.wpcf7-acceptance input[type="checkbox"]');
	const submitButton = document.querySelector('.wpcf7-submit');

	console.log('Checkboxes:', checkboxes);
	console.log('Submit button:', submitButton);

	if (!submitButton) return;

	const allChecked = Array.from(checkboxes).every(cb => cb.checked);
	if (allChecked) {
		submitButton.removeAttribute('disabled');
	} else {
		submitButton.setAttribute('disabled', '');
	}
}


// Optional: Handle initial state if a radio is pre-selected
const checkedRadio = document.querySelector('.wpcf7-radio .wpcf7-list-item input[type="radio"]:checked');
if (checkedRadio) {
	checkedRadio.closest('.wpcf7-radio .wpcf7-list-item').classList.add('active');
}

document.addEventListener('wpcf7mailsent', function(event) {
	// Get the form element that was just submitted
	const form = event.target;

	// Reset all radio buttons and remove their active classes
	const radioItems = form.querySelectorAll('.wpcf7-radio .wpcf7-list-item');
	radioItems.forEach(item => {
		item.classList.remove('active');
		const radioInput = item.querySelector('input[type="radio"]');
		if (radioInput) {
			radioInput.checked = false;
		}
	});

	// Reset all checkboxes and remove their active classes
	const acceptanceItems = form.querySelectorAll('.wpcf7-acceptance .wpcf7-list-item');
	acceptanceItems.forEach(item => {
		item.classList.remove('active');
		const checkboxInput = item.querySelector('input[type="checkbox"]');
		if (checkboxInput) {
			checkboxInput.checked = false;
		}
	});

	// Optionally reset the subject field (if it's an input with a specific class or id)
	const subjectField = form.querySelector('input[name="your-subject"]');
	if (subjectField) {
		subjectField.value = '';
	}

	// Optionally, disable the submit button again if that's part of your logic
	const submitButton = form.querySelector('input[type="submit"]');
	if (submitButton) {
		submitButton.setAttribute('disabled', '');
	}
});


document.addEventListener('DOMContentLoaded', function() {
	// Select all FAQ header elements
	var faqHeaders = document.querySelectorAll('.faq h6');

	faqHeaders.forEach(function(header) {
		header.addEventListener('click', function() {
			// Toggle the active class on the clicked header
			header.classList.toggle('active');

			// Get the associated FAQ text element (assumed to be the next sibling)
			var faqText = header.nextElementSibling;
			if (!faqText) return;

			// If already open, slide up (close)
			if (faqText.style.maxHeight) {
				faqText.style.maxHeight = null;
			} else {
				// Open the element: set its max-height to its scrollHeight to enable a slide down effect.
				faqText.style.maxHeight = faqText.scrollHeight + "px";
			}
		});
	});
});

function toggleSlickOnMobile() {
	jQuery('.hero-v2__market-list').each(function () {
		var $slider = jQuery(this);
		var settings = {
			slidesToShow: 1,
			slidesToScroll: 1,
			dots: false,
			arrows: false,
			infinite: false,
			// Це треба, щоб slick не ламав ширину — ДИВИСЬ ДАЛІ
			centerMode: false,
			variableWidth: true
		};

		if (window.innerWidth <= 1024) {
			if (!$slider.hasClass('slick-initialized')) {
				$slider.slick(settings);
			}
		} else {
			if ($slider.hasClass('slick-initialized')) {
				$slider.slick('unslick');
			}
		}
	});
}

jQuery(document).ready(function () {
	toggleSlickOnMobile();
});
window.addEventListener('resize', function () {
	clearTimeout(window.__slickResizeTimeout);
	window.__slickResizeTimeout = setTimeout(toggleSlickOnMobile, 150);
});

document.addEventListener('DOMContentLoaded', function() {
	// 1. SEPIA toggle (body class)
	document.querySelectorAll('.sepia').forEach(function(btn) {
		btn.addEventListener('click', function() {
			const isDark = document.body.classList.contains('dark-theme') ||
				(localStorage.getItem('theme') === 'dark');

			if (isDark) {
				// Switch to light theme and reload page
				localStorage.setItem('theme', 'light');
				document.cookie = 'theme=light; path=/; SameSite=Lax';
				location.reload();
				return;
			}
			// On light theme — just toggle sepia (NO localStorage for sepia)
			document.body.classList.toggle('sepia-view');
			btn.classList.toggle('active');
		});
	});

	// 2. FULL WIDTH toggle (.article__content class)
	document.querySelectorAll('.text-full-with').forEach(function(btn) {
		btn.addEventListener('click', function() {
			document.querySelectorAll('.article__content').forEach(function(el) {
				el.classList.toggle('text-full-with-view');
			});
			btn.classList.toggle('active');
		});
	});

	// 3. FONT SIZE toggle (multiple classes)
	const fontClasses = ['font-sm', '', 'font-lg', 'font-xl'];
	let currentFontIndex = 1; // default (medium)
	const contentEls = document.querySelectorAll('.article__the-content');

	function updateFontSize() {
		contentEls.forEach(el => {
			fontClasses.forEach(cls => { if (cls) el.classList.remove(cls); });
			if (fontClasses[currentFontIndex]) el.classList.add(fontClasses[currentFontIndex]);
		});
	}

	document.querySelectorAll('.article__settings-btn-plus').forEach(function(btn) {
		btn.addEventListener('click', function() {
			if (currentFontIndex < fontClasses.length - 1) {
				currentFontIndex++;
				updateFontSize();
			}
			btn.classList.add('active');
			document.querySelectorAll('.article__settings-btn-minus').forEach(b => b.classList.remove('active'));
		});
	});
	document.querySelectorAll('.article__settings-btn-minus').forEach(function(btn) {
		btn.addEventListener('click', function() {
			if (currentFontIndex > 0) {
				currentFontIndex--;
				updateFontSize();
			}
			btn.classList.add('active');
			document.querySelectorAll('.article__settings-btn-plus').forEach(b => b.classList.remove('active'));
		});
	});
	updateFontSize();

	// 4. SHOW SOCIAL MODAL (no storage)
	document.querySelectorAll('.show-social').forEach(function(btn) {
		btn.addEventListener('click', function() {
			document.querySelectorAll('.modal-social').forEach(function(modal) {
				modal.classList.toggle('active');
			});
			btn.classList.toggle('active');
			document.body.classList.toggle('disable-scroll');
		});
	});

	// Close social modal on close button click
	document.querySelectorAll('.modal-social__close').forEach(function(btn) {
		btn.addEventListener('click', function() {
			// Find the nearest parent with .modal-social and remove class 'active'
			let modal = btn.closest('.modal-social');
			if (modal) {
				modal.classList.remove('active');
			}

			// Remove 'active' from ALL .show-social buttons/triggers
			document.querySelectorAll('.show-social').forEach(function(trigger) {
				trigger.classList.remove('active');
				document.body.classList.remove('disable-scroll');
			});
		});
	});



});

document.addEventListener("DOMContentLoaded", function () {
	const toggleBtn = document.querySelector(".ads-disclosure");
	const content = document.querySelector(".ads-disclosure-content");
	const closeBtn = document.querySelector(".ads-disclosure-content__close-btn");

	// Click to open
	toggleBtn.addEventListener("click", () => {
		content.classList.add("active");
	});

	// Click to close
	closeBtn.addEventListener("click", () => {
		content.classList.remove("active");
	});
});

document.addEventListener("DOMContentLoaded", function () {
	const triggers = document.querySelectorAll(".exchange--features-h, .exchange--features-btn");
	const target = document.querySelector(".exchange--features");

	if (!target) return;

	triggers.forEach(btn => {
		btn.addEventListener("click", () => {
			target.classList.toggle("active");
		});
	});
});

jQuery(document).ready(function ($) {
	if ($(window).width() < 768) {
		$('.exchange-comparisons__grid').slick({
			slidesToShow: 2,
			slidesToScroll: 1,
			arrows: false,
			dots: false,
			infinite: false,
			adaptiveHeight: true,
		});
	}
});